import type { BoletoResult, Sexo, TipoCelular } from "../types";

export const parseBoolean = (str: any | undefined): boolean => {
    // console.log({str});
    if (str === undefined) {
        return false;
    }
    if (typeof str === 'boolean') {
        return str
    }
    if (typeof str === 'string') {
        switch (String(str).toLowerCase()) {
            case "true":
            case "1":
            case "yes":
            case "y":
            case "si":
            case "s":
                return true;
            case "false":
            case "0":
            case "no":
            case "n":
                return false;
            default:
                return false; // Or throw an error, depending on desired behavior for unhandled cases
        }
    }

    return false;
}

export const ErrorToString = (error: unknown): string => {
    if (error instanceof Error) {
        return error.message;
    } else if (typeof error === 'string') {
        return error;
    } else {
        return 'Error desconocido';
    }
}

export const SexoStringToChar = (sexo: string): Sexo => {
    switch (sexo.toLowerCase()) {
        case 'masculino':
        case 'hombre':
        case 'varon':
        case 'h':
            return 'H';
        case 'femenino':
        case 'mujer':
        case 'hembra':
        case 'm':
            return 'M';
        case 'otro':
        case 'o':
            return 'O';
        case 'n/d':
            return 'N/A'
        default:
            return 'N/A';
    }
}

export const SexoToChar = (sexo: Sexo): string => {
    switch (sexo) {
        case 'H':
            return 'H';
        case 'M':
            return 'M';
        case 'O':
            return 'O';
        default:
            return 'N/A';
    }
}

export const SexoStringToList = (sexo: string): string => {
    switch (sexo.toLowerCase()) {
        case 'masculino':
        case 'hombre':
        case 'varon':
        case 'h':
            return 'Masculino';
        case 'femenino':
        case 'mujer':
        case 'hembra':
        case 'm':
            return 'Femenino';
        case 'otro':
        case 'o':
            return 'Otro';
        case 'n/d':
            return 'Prefiero no decir'
        default:
            return 'Prefiero no decir';
    }
}

export const qrData = (boleto: BoletoResult, pendiente = true) => {
    return `|${boleto.serie.trim()}|${boleto.folio}|${pendiente ? 'PENDIENTE DE PAGO' : boleto.firma}|2|\n`;
}


export const tipoCelUniform = (tipo: any): TipoCelular => {
    if (tipo === undefined || typeof tipo !== 'string') {
        return 'N/A';
    }
    switch (tipo.toLowerCase()) {
        case 'android':
            return 'Android';
        case 'iphone':
            return 'iPhone';
        case 'otro':
            return 'Otro';
        default:
            return 'N/A';
    }
}